import { RuleValidation } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { ProductDiscountThresholdRuleState } from './types'

export function validateProductDiscountThresholdRule(
	rule: ProductDiscountThresholdRuleState,
): RuleValidation {
	if (rule.discount === null || rule.discount > 100 || rule.discount <= 0) {
		return { isValid: false, errors: { discount: 'invalid' } }
	}
	if (rule.threshold === null || rule.threshold <= 0) {
		return { isValid: false, errors: { threshold: 'invalid' } }
	}
	if (!rule.products || rule.products.length === 0) {
		return { isValid: false, errors: { products: 'empty' } }
	}
	return { isValid: true, errors: {} }
}
